// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDetails_importCsvCard__OC6y0","addBtnContainer":"AddDetails_addBtnContainer__9Y+SG"};